import { queryKeys } from '@query/keys'
import { useQuery } from '@tanstack/react-query'
import { FC, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router-dom'

import { useAccountReadContext } from '@app/context/AccountContextContext'

import { PageSection } from '@ui/components/PageSection'
import { Tab } from '@ui/components/Tabs'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import { useScrollToTop } from '@hooks/useScrollToTop'

export const ReportsPage: FC = () => {
  useScrollToTop()
  const { t } = useTranslation()
  const apiClient = useApiClient(ClientApiClient)
  const { account } = useAccountReadContext()
  const introducingBrokerId = account?.clientIntroducingBroker?.id

  const { data } = useQuery({
    queryKey: queryKeys.ib.exportHubHasUnseen(introducingBrokerId),
    queryFn: () => apiClient.getExportHubHasUnseen(introducingBrokerId!),
    enabled: !!introducingBrokerId,
  })

  const tabs: Tab[] = useMemo(
    () => [
      { label: t('IB.Clients'), path: 'clients' },
      { label: t('IB.Income'), path: 'income' },
      { label: t('Tabs.IB Reports'), path: 'ib-reports' },
      { label: t('Tabs.Client Journey Map'), path: 'cjm' },
      { label: t('IB.Transactions History'), path: 'transactions-history' },
      {
        label: t('Tabs.Export Hub'),
        path: 'export-hub',
        alert: data?.hasUnseen,
      },
    ],
    [t, data?.hasUnseen]
  )

  return (
    <>
      <PageSection title={t('IB.ReportsPage.Metrics')} tabData={{ tabs }} />
      <Outlet />
    </>
  )
}
